// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"801":"d719b9a2","858":"d56981d1"}[chunkId] + ".chunk.js";
};